import createReducer, { mergeReducers } from "../../../lib/createReducer";
import { SYNC_MODELS_ERROR, SYNC_MODELS_REQUEST, SYNC_MODELS_SUCCESS } from "./action";

const init = {
  isFetching: false,
  fetchSuccess: false,
  hasError: false,
  payload: null,
  error: null,
};

const requestReducer = createReducer(
  SYNC_MODELS_REQUEST,
  () => ({
    ...init,
    isFetching: true,
  }),
  true
);

const successReducer = createReducer(SYNC_MODELS_SUCCESS, ({ response }) => ({
  isFetching: false,
  fetchSuccess: true,
  payload: response,
}));

const errorReducer = createReducer(SYNC_MODELS_ERROR, ({ error }) => ({
  isFetching: false,
  hasError: true,
  error,
}));

export default mergeReducers([requestReducer, successReducer, errorReducer], init);
